module.exports = __webpack_public_path__ + "img/fc3fd22.png";